export default __webpack_public_path__ + "static/media/withlogo.004.b6842619.jpeg";